const devilNote = require('./devil')

module.exports = [
  {
    text: `Тиамат — это сила Хаоса, привязанная к месту Порядка. Являются ли абишаи её слугами или же надзирателями?`,
    author: `Архимаг Морденкайнен`,
  },
  ...devilNote,
]
